/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiOtpVerificaOtpGet$Params {
    /**
     * Utente a cui si vuole inviare la notifica OTP
     */
    nomeUtente: string;

    /**
     * secondi di validità del token OTP, se non viene specificato prende il valore di default (30 secondi)
     */
    codiceOTP: string;
}

export function apiOtpVerificaOtpGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiOtpVerificaOtpGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiOtpVerificaOtpGet.PATH, 'get');
    if (params) {
        rb.query('nomeUtente', params.nomeUtente, {});
        rb.query('codiceOTP', params.codiceOTP, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiOtpVerificaOtpGet.PATH = '/api/otp/verifica-otp';
